<template>
    <div :class="classList">
        <slot></slot>
    </div>
</template>

<script>
    import AlignmentClassesMixin from "../../mixins/AlignmentClassesMixin";
    import ResponsiveClassesMixin from "../../mixins/ResponsiveClassesMixin";

    export default {
        mixins: [AlignmentClassesMixin, ResponsiveClassesMixin],
        props: {
            reversed: {
                type: Boolean,
                default: false
            },
            cols: {
                type: [String, Number, null],
                default: null
            },
            xs: {
                type: [String, Number, null],
                default: null
            },
            sm: {
                type: [String, Number, null],
                default: null
            },
            md: {
                type: [String, Number, null],
                default: null
            },
            lg: {
                type: [String, Number, null],
                default: null
            },
            xl: {
                type: [String, Number, null],
                default: null
            },
        },
        computed: {
            classList() {
                let classList = [Object.assign({
                    'flex': true,
                    // 'flex-1': !this.shrink && (!this.cols || (!this.xs && !this.sm && !this.md && !this.lg && !this.xl)),
                    'flex-col': !this.reversed,
                    'flex-col-reverse': this.reversed,
                }, this.alignmentClasses, this.responsiveClasses)];
                if (this.cols) {
                    classList.push('w-' + this.cols);
                }
                ['xs', 'sm', 'md', 'lg', 'xl'].forEach(prop => !!this[prop] && classList.push(prop + ':w-' + this[prop]));
                return classList;
            }
        }
    };
</script>